module.exports = __webpack_public_path__ + "img/See-a-DEMO-popup1-en.c1aa2af.png";